export const ErrorHandler =
(
  <div className="">
    Oh no! There was an  error
  </div>
);
